import { unitConverter } from 'utils/unitConverter/unitConverter'
import type { Rule } from '../_types'

type ConvertibleRule = Rule | { unit: string | null; value: string; key: string }

export type TInputOutputUnit = 'c' | 'f'

const isValidNumberForConversion = (value: Rule['value']): boolean => {
  if (typeof value === 'number') {
    return value !== 0 && Number.isFinite(value)
  }

  if (typeof value === 'string') {
    if (value.trim() === '') return false

    const num = Number(value.trim())

    return num !== 0 && Number.isFinite(num)
  }

  return false
}

export const convertAlertRulesIfApplicable = ({
  rule,
  inputUnit,
  outputUnit,
}: {
  rule: ConvertibleRule
  inputUnit: TInputOutputUnit
  outputUnit: TInputOutputUnit
}) => {
  if (rule.value === null || !isValidNumberForConversion(rule.value)) {
    return rule.value
  }

  const numericValue = +rule.value

  switch (rule.unit) {
    case 'temperature': {
      return unitConverter
        .temperatureBelowCanopy(numericValue, {
          inputUnit,
          outputUnit,
        })
        .value()
    }

    case 'inversion': {
      if (rule.key === 'degreeDays') {
        return unitConverter
          .insectDegreeDays(numericValue, {
            inputUnit,
            outputUnit,
          })
          .value()
      }

      return unitConverter
        .temperatureInversion(numericValue, {
          inputUnit,
          outputUnit,
        })
        .value()
    }

    default: {
      return rule.value
    }
  }
}
